import { fetcher } from "helpers/fetcher";

import { TGetStaffApplicationMediumsRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffApplicationMediums = async (userId: string) => {
  return await fetcher<TGetStaffApplicationMediumsRes, any>(
    ENDPOINT.USER.GET_STAFF_APPLICATION_MEDIUM,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_STAFF_APPLICATION_MEDIUM.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffApplicationMediums = async (userId: string) => {
  return (await getStaffApplicationMediums(userId)).data;
};

queryGetStaffApplicationMediums._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_APPLICATION_MEDIUM.url,
  userId,
];
